import axios from "axios";

const rootUrl = process.env.REACT_APP_BASE_API_URL;

export default axios.create({
  baseURL: rootUrl,
});
